import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemeListesiv2EvrakDetayTedarikci_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemeListesiv2EvrakDetayTedarikci_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  YuklemePlan_Get_TeslimEvrakListe: any[];
  YuklemePlan_Get_TeslimEvrakListe_dummy: any[];
  YuklemePlan_Get_EvrakOnayDetails: any[];
  YuklemePlan_Get_EvrakOnayDetails_dummy: any[];
  YuklemePlan_EvrakGuncelleTedarikci: number;
  YuklemePlan_EvrakGuncelleTedarikci_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  PhotosFromGallery: any[];
  PhotosFromGallery_dummy: any[];
  YuklemePlan_Save_TeslimEvrak: any[];
  YuklemePlan_Save_TeslimEvrak_dummy: any[];
  isComp479436Enabled: "enabled" | "disabled";
}

export class YuklemeListesiv2EvrakDetayTedarikci_ScreenBase extends React.PureComponent<
  IYuklemeListesiv2EvrakDetayTedarikci_ScreenProps,
  any
> {
  yuklemelistesiv2evrakdetaytedarikci_485635_value_kuikaCarouselRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "11eab486-a586-42af-89c6-35c204f8c06d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 409199,
          PropertyName: "value",
          Value: "Teslimat Evrak Kontrol Ekranı",
        },
        { Id: 433345, PropertyName: "value", Value: "Yükleme No" },
        { Id: 352785, PropertyName: "value", Value: "Teslimat No" },
        { Id: 160497, PropertyName: "value", Value: "Müşteri" },
        { Id: 205964, PropertyName: "value", Value: "Teslim Yeri" },
        { Id: 235229, PropertyName: "value", Value: "Teslim Tarihi" },
        { Id: 358423, PropertyName: "value", Value: "İade Var Mı" },
        { Id: 866602, PropertyName: "value", Value: "Hasarlı İade Var Mı ?" },
        { Id: 337070, PropertyName: "value", Value: "Hasarlı İade Miktar" },
        { Id: 923402, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 318840, PropertyName: "value", Value: "Eksik Fazla Var Mı ?" },
        { Id: 451568, PropertyName: "value", Value: "Eksik - Fazla Miktar" },
        { Id: 920150, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 367880, PropertyName: "value", Value: "Teslimat" },
        { Id: 479436, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 791365, PropertyName: "value", Value: "İrsaliye No" },
        { Id: 433761, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 942684, PropertyName: "label", Value: "Kaydet" },
        {
          Id: 485635,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 86143, PropertyName: "label", Value: "Evrak Yükle" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemelistesiv2evrakdetaytedarikci_923402_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetaytedarikci_920150_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetaytedarikci_479436_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetaytedarikci_433761_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetaytedarikci_485635_value_kuikaCarouselRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      YuklemePlan_Get_TeslimEvrakListe: [],
      YuklemePlan_Get_EvrakOnayDetails: [],
      YuklemePlan_EvrakGuncelleTedarikci: 0,
      Notify: false,
      PhotosFromGallery: [],
      YuklemePlan_Save_TeslimEvrak: [],
      isComp479436Enabled: "disabled",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "yuklemelistesiv2evrakdetaytedarikci",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemeListesiv2EvrakDetayTedarikciPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "yuklemelistesiv2evrakdetaytedarikci",
      ""
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["Tedarikci"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "yuklemelistesiv2evrakdetaytedarikci",
      ""
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemeListesiv2EvrakDetayTedarikciPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemelistesiv2evrakdetaytedarikci_153582_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.iadeVar ??
        undefined,
      yuklemelistesiv2evrakdetaytedarikci_979979_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.hasarIade ??
        undefined,
      yuklemelistesiv2evrakdetaytedarikci_923402_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.hasarliMiktar ??
        undefined,
      yuklemelistesiv2evrakdetaytedarikci_574378_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.eksikFazla ??
        undefined,
      yuklemelistesiv2evrakdetaytedarikci_920150_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)
          ?.eksikFazlaMiktar ?? undefined,
      yuklemelistesiv2evrakdetaytedarikci_479436_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.aciklama ??
        undefined,
      yuklemelistesiv2evrakdetaytedarikci_433761_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.irsaliyeNo ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemeListesiv2EvrakDetayTedarikciPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakDetayTedarikciPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayTedarikciPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
      FirmaNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakDetayTedarikci/YuklemeListesiv2EvrakDetayTedarikciPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.YuklemePlan_Get_TeslimEvrakListe =
      result?.data.yuklemePlan_Get_TeslimEvrakListe;

    stateVars.YuklemePlan_Get_EvrakOnayDetails =
      result?.data.yuklemePlan_Get_EvrakOnayDetails;
    formVars.yuklemelistesiv2evrakdetaytedarikci_21608_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_544116_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimatNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimatNo
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_670925_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].musteriAdi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].musteriAdi
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_458207_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].varisNoktaAdi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].varisNoktaAdi
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_860922_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimTarihi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimTarihi
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_153582_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].iadeVar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].iadeVar
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_979979_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].hasarIade
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].hasarIade
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_923402_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].hasarliMiktar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].hasarliMiktar
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_574378_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazla
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazla
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_920150_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazlaMiktar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazlaMiktar
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_479436_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].aciklama
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].aciklama
          : null
      );
    formVars.yuklemelistesiv2evrakdetaytedarikci_433761_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].irsaliyeNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].irsaliyeNo
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakDetayTedarikciPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayTedarikciPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemelistesiv2evrakdetaytedarikci_21608_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_544116_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimatNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimatNo
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_670925_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].musteriAdi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].musteriAdi
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_458207_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].varisNoktaAdi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].varisNoktaAdi
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_860922_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimTarihi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimTarihi
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_153582_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].iadeVar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].iadeVar
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_979979_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].hasarIade
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].hasarIade
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_923402_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].hasarliMiktar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].hasarliMiktar
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_574378_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazla
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazla
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_920150_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazlaMiktar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazlaMiktar
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_479436_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].aciklama
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].aciklama
          : null
      );

    formVars.yuklemelistesiv2evrakdetaytedarikci_433761_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].irsaliyeNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].irsaliyeNo
          : null
      );

    stateVars.dataSource_485635 =
      stateVars.YuklemePlan_Get_TeslimEvrakListe ??
      this.state.YuklemePlan_Get_TeslimEvrakListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayTedarikciComponent_942684_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "string"
      ),
      Aciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetaytedarikci_479436_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EksikFazlaVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetaytedarikci_574378_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      EksikFazlaMiktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetaytedarikci_920150_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      HasarIadeVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetaytedarikci_979979_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      HasarliMiktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetaytedarikci_923402_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      IadeVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetaytedarikci_153582_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakDetayTedarikci/YuklemeListesiv2EvrakDetayTedarikciComponent_942684_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_EvrakGuncelleTedarikci =
      result?.data.yuklemePlan_EvrakGuncelleTedarikci;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakDetayTedarikciComponent_942684_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayTedarikciComponent_942684_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "6e9e8bc2_59f1_6a5e_3a2e_ec1b9ed1d622_notify",
        this.defaultML,
        "Bilgiler Kaydedildi"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayTedarikciComponent_86143_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.PhotosFromGallery = (
      (await ReactSystemFunctions.getPhotosFromGallery(
        false,
        ReactSystemFunctions.convertToTypeByName("high", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakDetayTedarikciComponent_86143_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayTedarikciComponent_86143_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
      DocumentData_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].dataBase64
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].dataBase64
            : null
        ),
        "string"
      ),
      DocumentName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].name
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].name
            : null
        ),
        "string"
      ),
      YuklemeTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("KONTROL EKRAN", "string"),
        "string"
      ),
      SmsResent_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakDetayTedarikci/YuklemeListesiv2EvrakDetayTedarikciComponent_86143_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Save_TeslimEvrak =
      result?.data.yuklemePlan_Save_TeslimEvrak;
    stateVars.YuklemePlan_Get_TeslimEvrakListe =
      result?.data.yuklemePlan_Get_TeslimEvrakListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakDetayTedarikciComponent_86143_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayTedarikciComponent_86143_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f448f21f_2bd3_df07_2f02_58e240fc3262_notify",
        this.defaultML,
        "EVRAK YÜKLENDİ"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_485635 =
      stateVars.YuklemePlan_Get_TeslimEvrakListe ??
      this.state.YuklemePlan_Get_TeslimEvrakListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemeListesiv2EvrakDetayTedarikciPageInit();
    }
  }
}
